module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00023.f7745df2.png";